<script lang="ts">
  import * as Command from "$lib/components/ui/command/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { createEventDispatcher, tick } from "svelte";
  import CaretSort from "svelte-radix/CaretSort.svelte";
  import Check from "svelte-radix/Check.svelte";
  import { cn } from "$lib/utils";
  import { DueDateType } from "$src/domain/projects/details/PaymentSchedule";
  import DueDateTypeText from "./due-date-type-text.svelte";

  let open = false;

  const dispatch = createEventDispatcher();

  export let value: DueDateType;
  export let disabled: boolean = false;

  const items = [
    {
      id: 1,
      type: DueDateType.ManualDate,
    },
    {
      id: 2,
      type: DueDateType.AfterOrder,
    },
    {
      id: 3,
      type: DueDateType.BeforeInstallation,
    },
    {
      id: 4,
      type: DueDateType.AfterInstallation,
    },
  ];

  // We want to refocus the trigger button when the user selects
  // an item from the list so users can continue navigating the
  // rest of the form with the keyboard.
  function closeAndFocusTrigger(triggerId: string) {
    open = false;
    tick().then(() => {
      document.getElementById(triggerId)?.focus();
    });

    dispatch('dueDateSelected', value);
  }
</script>

<Popover.Root bind:open let:ids>
  <Popover.Trigger asChild let:builder>
    <Button
      builders={[builder]}
      variant="outline"
      role="combobox"
      aria-expanded={open}
      {disabled}
      class="w-[170px] justify-between text-xs "
    >
      <DueDateTypeText type={value} />
      <CaretSort class="ml-2 h-4 w-4 shrink-0 opacity-50" />
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-[200px] p-0">
    <Command.Root>
      <!-- <Command.Input placeholder="Search framework..." class="h-9" />
          <Command.Empty>No framework found.</Command.Empty> -->
      <Command.Group>
        {#each items as item}
          <Command.Item
            value={item.id.toString()}
            onSelect={(currentValue) => {
              var selectedItem = items.find(
                (i) => i.id.toString() == currentValue
              );
              if (selectedItem) {
                value = selectedItem.type;
              }
              closeAndFocusTrigger(ids.trigger);
            }}
          >
            <Check
              class={cn(
                "mr-2 h-4 w-4",
                value !== item.type && "text-transparent"
              )}
            />
            <DueDateTypeText type={item.type} />
          </Command.Item>
        {/each}
      </Command.Group>
    </Command.Root>
  </Popover.Content>
</Popover.Root>
